import styled from "styled-components";

const Container = styled.div`
  /* padding: 0 30px; */
`;

const Wrapper = styled.div`
  overflow: auto;
  &.filter {
    border-bottom: 1px solid #d1d0cb;
    max-height: 227px;
  }
  &.with-filter {
    max-height: calc(100vh - 398px);
  }
  &.un-filter {
    max-height: calc(100vh - 173px);
  }
`;

const CardViewWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 35px 28px;
  padding: 32px 0;
  background-color: #fff;
`;

const ListViewWrapper = styled.div`
  table {
    width: 100%;
  }
  .table-head {
    th {
      text-align: left;
    }
  }
    @media(max-width:850px){
        &.table-ui {
        padding: 0 5px !important;
    }
  }
  .speedLimit{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 1;
    border: 1px solid #000;
  }
  .maxHole {
    color: white;
    font-size: 13px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    &.u {
      background-color: green;
    }
    &.max {
      background-color: red;
    }
  }
  &.table-ui {
    gap: 4px;
    padding: 0 26px;

    table {
      width: 100%;
      text-align: left;
      border-collapse: collapse;
      border-collapse: separate;
      border-spacing: 0 5px;

      tr {
        background: #ffffff;
        :nth-child(odd) td {
          background: #f4f4d4;
        }
      }
      tr.table-head {
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 1;
      }
    }
    tr th {
      font-size: 12px;
      line-height: 150.5%;
      text-transform: uppercase;
      padding: 10px 8px;
      background-color: #fafcff;
      .headSortIcon {
        position: absolute;
      }
      :first-child {
        border-left: 5px solid transparent;
        width: 62px;
        text-align: center;
      }
      :nth-child(2) {
        text-align: center;
      }
    }
    .body {
      box-shadow: 0px 4px 15px #0000001a;
    }
    tr td {
      font-size: 12px;
      line-height: 150%;
      color: var(--text-primary);
      padding: 2px 8px;
      :nth-child(2) {
        text-align: center;
      }
    }
    .car-number {
      font-size: 14px;
      line-height: 150%;
      color: var(--text-primary);
      cursor: pointer;
      position: relative;
      text-align: center;
    }
    .iconSlot {
      min-width: 24px;
      height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
    .chat-icon-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      > span,
      > div {
        display: inline-flex;
        align-items: center;
      }
      button {
        background: linear-gradient(
          180deg,
          #d9d9d9 0%,
          rgba(217, 217, 217, 0) 100%
        );
        border: 1px solid #636f7c;
        border-radius: 6px;
        padding: 0;
        width: 30px;
        height: 26.36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
    .signal-icon-wrapper {
      width: 200px;
      line-height:150%;
      > div {
        display: flex;
        align-items: center;
        gap: 44px;
        justify-content: flex-end;
      }
      > div > div > div {
        display: inline-flex;
        align-items: center;
      }
    }
  }
`;

const TableViewWrapper = styled.div``;
const InnerList = styled.div`
  display: flex;
  gap: 20px;
  padding: 32px 30px;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(349px, 1fr));

  &.grid-view-outer-div {
    gap: 25px;
    grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  }
  @media (max-width: 850px) {
    padding: 13px 13px;
    gap: 10px;
  }
`;

export {
    Container,
    Wrapper,
    CardViewWrapper,
    ListViewWrapper,
    TableViewWrapper,
    InnerList,
};
